/* PEAK pre-sell phone Shop bar - CVR v21 (austin-cc, 2026-09-30).
   Markup + rules: snippets/pkj-cvr-v21-presell-bar.liquid. Styles: assets/pkj-cvr-v21-presell-bar.css.
   Sub-row pill: snippets/pkj-cvr-v21-presell-shop.liquid (this file only tracks its clicks and, on one-model
   series pages, points it at that model's PDP). */
(() => {
  'use strict';
  const bar = document.getElementById('pkj-ps-bar');
  const cta = bar && bar.querySelector('[data-pkj-ps-bar-cta]');
  if (!bar || !cta || !('IntersectionObserver' in window)) return;

  const phone = matchMedia('(max-width: 899px)');
  const root = document.documentElement;
  const nav = document.querySelector('#MainContent [data-pkj-scroll-nav]') || document.querySelector('[data-pkj-scroll-nav]');
  const compare = document.getElementById('compare');
  const hero = document.querySelector('.pkj-discovery-title .pkj-btn, .pkj-outdoor-title .pkj-btn, .pkji-opening .pkj-btn');
  const own = [hero].concat(compare ? [...compare.querySelectorAll('.pkj-btn')] : []).filter(Boolean);
  const ends = [document.querySelector('#MainContent .pkj-close'), document.getElementById('shopify-section-pkj-footer')].filter(Boolean);
  /* Series pages send the bar to #compare: no bar while that section is on screen (the model cards are the shop step). */
  const hashTarget = () => { const h = cta.getAttribute('href') || ''; return h.charAt(0) === '#' ? document.getElementById(h.slice(1)) : null; };
  let on = false, seen = false, typing = false, heroPast = !hero, queued = false;
  const ownIn = new Set(), endIn = new Set();

  /* One-model series (PEAK Mini): skip the one-card #compare stop and go straight to the PDP. */
  if (bar.dataset.kind === 'series' && compare) {
    const paths = [...new Set([...compare.querySelectorAll('a[href*="/products/"]')].map(a => a.pathname))];
    if (paths.length === 1) {
      cta.setAttribute('href', paths[0]);
      document.querySelectorAll('a[data-pkj-ps-shop][href="#compare"]').forEach(a => a.setAttribute('href', paths[0]));
    }
  }
  const target = () => ((cta.getAttribute('href') || '').charAt(0) === '#' ? 'compare' : 'pdp');

  function track(name, params) {
    try {
      const p = Object.assign({placement: 'presell_bottom_bar', page_kind: bar.dataset.kind, shop_name: bar.dataset.name, target: target()}, params);
      /* peak-analytics (PK.track) adds the pk_ schema, consent check and Clarity tags. */
      const PK = (window.PK = window.PK || {});
      if (typeof PK.track === 'function') PK.track(name, p);
      else (PK.queue = PK.queue || []).push([name, p]); /* peak-analytics flushes PK.queue on load */
    } catch {}
  }

  /* Shopify's theme-preview bar sits at the bottom in draft previews; stand on top of it. The offset lives on
     <html> so the Chat pill lift can use it too. */
  function offset() {
    let px = 0;
    const pb = document.getElementById('preview-bar-iframe') || document.getElementById('PBarNextFrameWrapper');
    if (pb) {
      const r = pb.getBoundingClientRect();
      if (r.height > 0 && r.top < innerHeight && r.bottom >= innerHeight - 2) px = Math.round(innerHeight - r.top);
    }
    root.style.setProperty('--pkj-ps-offset', px + 'px');
  }

  function blocked() {
    if (typing || document.body.classList.contains('pkj-menu-open')) return true;
    const consent = document.getElementById('shopify-pc__banner');
    return !!(consent && consent.getBoundingClientRect().height > 0 && getComputedStyle(consent).visibility !== 'hidden');
  }

  function set(v) {
    if (v === on) return;
    on = v;
    if (v) { offset(); if (bar.hidden) { bar.hidden = false; void bar.offsetWidth; } }
    bar.classList.toggle('is-on', v);
    bar.inert = !v;
    bar.setAttribute('aria-hidden', v ? 'false' : 'true');
    document.body.classList.toggle('pkj-ps-bar-on', v);
    if (v && !seen) { seen = true; track('pk_presell_sticky_view'); }
  }

  function update() {
    queued = false;
    set(phone.matches && heroPast && ownIn.size === 0 && endIn.size === 0 && !blocked());
  }
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };

  /* The sticky chapter row covers the top of the screen; a hero button under it counts as scrolled away. */
  const navH = () => (nav ? Math.round(nav.getBoundingClientRect().height) : 0);
  let heroIO = null, heroMargin = -1;
  function watchHero() {
    if (!hero) return;
    const m = navH();
    if (heroIO && m === heroMargin) return; /* iOS fires resize on every URL-bar move; rebuild only when the row height changes */
    heroMargin = m;
    if (heroIO) heroIO.disconnect();
    heroIO = new IntersectionObserver(entries => {
      for (const e of entries) heroPast = !e.isIntersecting && e.boundingClientRect.top < (e.rootBounds ? e.rootBounds.top : 0) + 1;
      schedule();
    }, {rootMargin: `-${m}px 0px 0px 0px`});
    heroIO.observe(hero);
  }
  watchHero();

  const ownIO = new IntersectionObserver(entries => {
    for (const e of entries) e.isIntersecting ? ownIn.add(e.target) : ownIn.delete(e.target);
    schedule();
  });
  own.forEach(el => ownIO.observe(el)); /* hero button + #compare buttons: the bar hides while any is on screen */

  /* Closing block + footer: once the top of one reaches the screen, the bar stays off below it (also over the
     newsletter band between them). #compare on series pages: off only while it is on screen. */
  const endIO = new IntersectionObserver(entries => {
    for (const e of entries) {
      const top = e.rootBounds ? e.rootBounds.top : 0;
      (e.isIntersecting || e.boundingClientRect.bottom <= top) ? endIn.add(e.target) : endIn.delete(e.target);
    }
    schedule();
  });
  ends.forEach(el => endIO.observe(el));
  const zone = hashTarget();
  if (zone) ownIO.observe(zone);

  /* Keyboard up (a field is focused): step aside so the bar does not sit on the keyboard. */
  const isField = el => !!(el && el.matches && el.matches('input:not([type=button]):not([type=submit]):not([type=checkbox]):not([type=radio]):not([type=hidden]),textarea,select,[contenteditable=""],[contenteditable="true"]'));
  document.addEventListener('focusin', e => { if (isField(e.target)) { typing = true; schedule(); } });
  document.addEventListener('focusout', e => { if (isField(e.target)) { typing = false; setTimeout(schedule, 50); } });

  /* Menu open/close and the cookie banner change body classes / DOM without scrolling. */
  new MutationObserver(schedule).observe(document.body, {attributes: true, attributeFilter: ['class']});
  (phone.addEventListener ? phone.addEventListener('change', schedule) : phone.addListener(schedule));
  addEventListener('resize', () => { watchHero(); offset(); schedule(); }, {passive: true});
  addEventListener('load', () => { offset(); schedule(); });

  /* Bar tap. PDP targets are plain links. #compare uses the page's own chapter link (same scroll offset
     and history as the chapter row), else a smooth scroll. */
  cta.addEventListener('click', event => {
    track('pk_presell_sticky_click');
    const href = cta.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    event.preventDefault();
    const chapter = nav && nav.querySelector(`[data-pkj-chapter][href="${href}"]`);
    if (chapter) { chapter.click(); return; }
    const el = document.getElementById(href.slice(1));
    if (el) el.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
  });

  /* Sub-row pill clicks (phones + desktop). */
  document.querySelectorAll('a[data-pkj-ps-shop]').forEach(a => a.addEventListener('click', () => {
    track('pk_presell_subrow_click', {placement: 'presell_subrow', target: (a.getAttribute('href') || '').charAt(0) === '#' ? 'compare' : 'pdp', viewport: phone.matches ? 'phone' : 'desktop'});
  }));

  schedule();
})();
